export default __webpack_public_path__ + "static/media/protactor.bf9606d9.svg";